"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiLineTextField = exports.MultiLineTextFieldArgs = exports.EmailTextField = exports.EmailTextFieldArgs = exports.LoginTextField = exports.LoginTextFieldArgs = exports.SchoolYearTextField = exports.SchoolYearTextFieldArgs = void 0;
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_textfield_1 = require("./il-textfield");
// arguments
exports.SchoolYearTextFieldArgs = {
    placeholder: 'Name of School Year',
    variant: enums_1.TextFieldVariantEnum.OUTLINED,
    color: enums_1.ColorPaletteEnum.PRIMARY,
};
exports.SchoolYearTextField = (0, get_component_1.getComponent)(il_textfield_1.ILTextField, exports.SchoolYearTextFieldArgs);
exports.LoginTextFieldArgs = {
    placeholder: 'Username or Email Address',
    variant: enums_1.TextFieldVariantEnum.OUTLINED,
    color: enums_1.ColorPaletteEnum.PRIMARY,
};
exports.LoginTextField = (0, get_component_1.getComponent)(il_textfield_1.ILTextField, exports.LoginTextFieldArgs);
exports.EmailTextFieldArgs = {
    placeholder: 'Your Email Address',
    variant: enums_1.TextFieldVariantEnum.OUTLINED,
    color: enums_1.ColorPaletteEnum.PRIMARY,
};
exports.EmailTextField = (0, get_component_1.getComponent)(il_textfield_1.ILTextField, exports.EmailTextFieldArgs);
exports.MultiLineTextFieldArgs = {
    placeholder: '',
    minRows: 4,
    maxRows: 6,
    multiline: true,
    variant: enums_1.TextFieldVariantEnum.OUTLINED,
    color: enums_1.ColorPaletteEnum.PRIMARY,
};
exports.MultiLineTextField = (0, get_component_1.getComponent)(il_textfield_1.ILTextField, exports.MultiLineTextFieldArgs);
